import { BreakPointsAndValues } from '../../../utilities/fluid/types';

export enum DeviceSize {
  MOBILE,
  TABLET,
  XL,
  LG,
}

const drop = 1.0;
function getBaseSize(deviceSize: DeviceSize) {
  switch (deviceSize) {
    case DeviceSize.MOBILE:
      return 16 * drop;
    case DeviceSize.TABLET:
      return 18 * drop;
    case DeviceSize.LG:
      return 19.47 * drop;
    case DeviceSize.XL:
      return 24 * drop;
  }
}

export function getFontScale(deviceSize: DeviceSize) {
  switch (deviceSize) {
    case DeviceSize.MOBILE:
      return 1.176;
    case DeviceSize.TABLET:
      return 1.29;
    case DeviceSize.LG:
      return 1.29;
    case DeviceSize.XL:
      return 1.32;
  }
}

// export function getFontScale(deviceSize: DeviceSize) {
//   switch (deviceSize) {
//     case DeviceSize.MOBILE:
//       return 1.198;
//     case DeviceSize.TABLET:
//       return 1.326;
//     case DeviceSize.LG:
//       return 1.326;
//     case DeviceSize.XL:
//       return 1.361;
//   }
// }

// export function getFontScale(deviceSize: DeviceSize) {
//   switch (deviceSize) {
//     case DeviceSize.MOBILE:
//       return 1.15;
//     case DeviceSize.TABLET:
//       return 1.262;
//     case DeviceSize.LG:
//       return 1.262;
//     case DeviceSize.XL:
//       return 1.262;
//   }
// }

export function getFontMultiplier(size: number, deviceSize: DeviceSize) {
  return Math.pow(getFontScale(deviceSize), size);
}

export function getFontSize(size: number, deviceSize: DeviceSize) {
  return getBaseSize(deviceSize) * Math.pow(getFontScale(deviceSize), size);
}

export function getFontSizes(sizeStep: number): BreakPointsAndValues {
  return [
    {
      width: 375,
      value: getFontSize(sizeStep, DeviceSize.MOBILE),
    },
    {
      width: 768,
      value: getFontSize(sizeStep, DeviceSize.TABLET),
    },
    {
      width: 1200,
      value: getFontSize(sizeStep, DeviceSize.LG),
    },
    {
      width: 1920,
      value: getFontSize(sizeStep, DeviceSize.XL),
    },
  ];
}
